import _defineProperty from "/var/lib/jenkins/workspace/workspace/mr-learner-frontend-production-china/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { genFocusStyle, resetComponent } from '../../style';
import { initMoveMotion, initSlideMotion, initZoomMotion, slideDownIn, slideDownOut, slideUpIn, slideUpOut } from '../../style/motion';
import getArrowStyle, { getArrowOffset } from '../../style/placementArrow';
import { genComponentStyleHook, mergeToken } from '../../theme/internal';
import genStatusStyle from './status'; // =============================== Base ===============================

var genBaseStyle = function genBaseStyle(token) {
  var _$concat, _Object$assign, _Object$assign4, _ref3;

  var componentCls = token.componentCls,
      menuCls = token.menuCls,
      zIndexPopup = token.zIndexPopup,
      dropdownArrowDistance = token.dropdownArrowDistance,
      sizePopupArrow = token.sizePopupArrow,
      antCls = token.antCls,
      iconCls = token.iconCls,
      motionDurationMid = token.motionDurationMid,
      dropdownPaddingVertical = token.dropdownPaddingVertical,
      fontSize = token.fontSize,
      dropdownEdgeChildPadding = token.dropdownEdgeChildPadding,
      colorTextDisabled = token.colorTextDisabled,
      fontSizeIcon = token.fontSizeIcon,
      controlPaddingHorizontal = token.controlPaddingHorizontal,
      colorBgElevated = token.colorBgElevated;
  return [_defineProperty({}, componentCls, Object.assign(Object.assign({}, resetComponent(token)), (_Object$assign = {
    position: 'absolute',
    top: -9999,
    left: {
      _skip_check_: true,
      value: -9999
    },
    zIndex: zIndexPopup,
    display: 'block',
    // A placeholder out of dropdown visible range to avoid close when user moving
    '&::before': {
      position: 'absolute',
      insetBlock: -dropdownArrowDistance + sizePopupArrow / 2,
      // insetInlineStart: -7, // FIXME: Seems not work for hidden element
      zIndex: -9999,
      opacity: 0.0001,
      content: '""'
    }
  }, _defineProperty(_Object$assign, "&-trigger".concat(antCls, "-btn"), _defineProperty({}, "& > ".concat(iconCls, "-down, & > ").concat(antCls, "-btn-icon > ").concat(iconCls, "-down"), {
    fontSize: fontSizeIcon
  })), _defineProperty(_Object$assign, "".concat(componentCls, "-wrap"), (_$concat = {
    position: 'relative'
  }, _defineProperty(_$concat, "".concat(antCls, "-btn > ").concat(iconCls, "-down"), {
    fontSize: fontSizeIcon
  }), _defineProperty(_$concat, "".concat(iconCls, "-down::before"), {
    transition: "transform ".concat(motionDurationMid)
  }), _$concat)), _defineProperty(_Object$assign, "".concat(componentCls, "-wrap-open"), _defineProperty({}, "".concat(iconCls, "-down::before"), {
    transform: "rotate(180deg)"
  })), _defineProperty(_Object$assign, "\n        &-hidden,\n        &-menu-hidden,\n        &-menu-submenu-hidden\n      ", {
    display: 'none'
  }), _defineProperty(_Object$assign, "&".concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-enter").concat(antCls, "-slide-down-enter-active").concat(componentCls, "-placement-bottomRight,\n          &").concat(antCls, "-slide-down-appear").concat(antCls, "-slide-down-appear-active").concat(componentCls, "-placement-bottomRight"), {
    animationName: slideUpIn
  }), _defineProperty(_Object$assign, "&".concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-enter").concat(antCls, "-slide-up-enter-active").concat(componentCls, "-placement-topRight,\n          &").concat(antCls, "-slide-up-appear").concat(antCls, "-slide-up-appear-active").concat(componentCls, "-placement-topRight"), {
    animationName: slideDownIn
  }), _defineProperty(_Object$assign, "&".concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottomLeft,\n          &").concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottom,\n          &").concat(antCls, "-slide-down-leave").concat(antCls, "-slide-down-leave-active").concat(componentCls, "-placement-bottomRight"), {
    animationName: slideUpOut
  }), _defineProperty(_Object$assign, "&".concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-topLeft,\n          &").concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-top,\n          &").concat(antCls, "-slide-up-leave").concat(antCls, "-slide-up-leave-active").concat(componentCls, "-placement-topRight"), {
    animationName: slideDownOut
  }), _Object$assign))), // =============================================================
  // ==                        Arrow style                      ==
  // =============================================================
  getArrowStyle(token, {
    colorBg: colorBgElevated,
    limitVerticalRadius: true,
    arrowPlacement: {
      top: true,
      bottom: true
    }
  }), (_ref3 = {}, _defineProperty(_ref3, "".concat(componentCls, " ").concat(menuCls), {
    position: 'relative',
    margin: 0
  }), _defineProperty(_ref3, "".concat(menuCls, "-submenu-popup"), {
    position: 'absolute',
    zIndex: zIndexPopup,
    background: 'transparent',
    boxShadow: 'none',
    transformOrigin: '0 0',
    'ul, li': {
      listStyle: 'none',
      margin: 0
    }
  }), _defineProperty(_ref3, "".concat(componentCls, ", ").concat(componentCls, "-menu-submenu"), _defineProperty({}, menuCls, Object.assign(Object.assign({
    padding: dropdownEdgeChildPadding,
    listStyleType: 'none',
    backgroundColor: colorBgElevated,
    backgroundClip: 'padding-box',
    borderRadius: token.borderRadiusLG,
    outline: 'none',
    boxShadow: token.boxShadowSecondary
  }, genFocusStyle(token)), (_Object$assign4 = {}, _defineProperty(_Object$assign4, "".concat(menuCls, "-item-group-title"), {
    padding: "".concat(dropdownPaddingVertical, "px ").concat(controlPaddingHorizontal, "px"),
    color: token.colorTextDescription,
    transition: "all ".concat(motionDurationMid)
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-item"), {
    position: 'relative',
    display: 'flex',
    alignItems: 'center'
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-item-icon"), {
    minWidth: fontSize,
    marginInlineEnd: token.marginXS,
    fontSize: token.fontSizeSM
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-title-content"), {
    flex: 'auto',
    '> a': {
      color: 'inherit',
      transition: "all ".concat(motionDurationMid),
      '&:hover': {
        color: 'inherit'
      },
      '&::after': {
        position: 'absolute',
        inset: 0,
        content: '""'
      }
    }
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-item, ").concat(menuCls, "-submenu-title"), Object.assign(Object.assign(_defineProperty({
    clear: 'both',
    margin: 0,
    padding: "".concat(dropdownPaddingVertical, "px ").concat(controlPaddingHorizontal, "px"),
    color: token.colorText,
    fontWeight: 'normal',
    fontSize: fontSize,
    lineHeight: token.lineHeight,
    cursor: 'pointer',
    transition: "all ".concat(motionDurationMid),
    borderRadius: token.borderRadiusSM
  }, "&:hover, &-active", {
    backgroundColor: token.controlItemBgHover
  }), genFocusStyle(token)), _defineProperty({
    '&-selected': {
      color: token.colorPrimary,
      backgroundColor: token.controlItemBgActive,
      '&:hover, &-active': {
        backgroundColor: token.controlItemBgActiveHover
      }
    },
    '&-disabled': {
      color: colorTextDisabled,
      cursor: 'not-allowed',
      '&:hover': {
        color: colorTextDisabled,
        backgroundColor: colorBgElevated,
        cursor: 'not-allowed'
      },
      a: {
        pointerEvents: 'none'
      }
    },
    '&-divider': {
      height: 1,
      margin: "".concat(token.marginXXS, "px 0"),
      overflow: 'hidden',
      lineHeight: 0,
      backgroundColor: token.colorSplit
    }
  }, "".concat(componentCls, "-menu-submenu-expand-icon"), _defineProperty({
    position: 'absolute',
    insetInlineEnd: token.paddingXS
  }, "".concat(componentCls, "-menu-submenu-arrow-icon"), {
    marginInlineEnd: '0 !important',
    color: token.colorTextDescription,
    fontSize: fontSizeIcon,
    fontStyle: 'normal'
  })))), _defineProperty(_Object$assign4, "".concat(menuCls, "-item-group-list"), {
    margin: "0 ".concat(token.marginXS, "px"),
    padding: 0,
    listStyle: 'none'
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-submenu-title"), {
    paddingInlineEnd: controlPaddingHorizontal + token.fontSizeSM
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-submenu-vertical"), {
    position: 'relative'
  }), _defineProperty(_Object$assign4, "".concat(menuCls, "-submenu").concat(menuCls, "-submenu-disabled ").concat(componentCls, "-menu-submenu-title"), _defineProperty({}, "&, ".concat(componentCls, "-menu-submenu-arrow-icon"), {
    color: colorTextDisabled,
    backgroundColor: colorBgElevated,
    cursor: 'not-allowed'
  })), _defineProperty(_Object$assign4, "".concat(menuCls, "-submenu-selected ").concat(componentCls, "-menu-submenu-title"), {
    color: token.colorPrimary
  }), _Object$assign4)))), _ref3), // Follow code may reuse in other components
  [initSlideMotion(token, 'slide-up'), initSlideMotion(token, 'slide-down'), initMoveMotion(token, 'move-up'), initMoveMotion(token, 'move-down'), initZoomMotion(token, 'zoom-big')]];
}; // ============================== Export ==============================


export default genComponentStyleHook('Dropdown', function (token, _ref) {
  var rootPrefixCls = _ref.rootPrefixCls;
  var marginXXS = token.marginXXS,
      sizePopupArrow = token.sizePopupArrow,
      controlHeight = token.controlHeight,
      fontSize = token.fontSize,
      lineHeight = token.lineHeight,
      paddingXXS = token.paddingXXS,
      componentCls = token.componentCls,
      borderRadiusLG = token.borderRadiusLG;
  var dropdownPaddingVertical = (controlHeight - fontSize * lineHeight) / 2;

  var _getArrowOffset = getArrowOffset({
    contentRadius: borderRadiusLG
  }),
      dropdownArrowOffset = _getArrowOffset.dropdownArrowOffset;

  var dropdownToken = mergeToken(token, {
    menuCls: "".concat(componentCls, "-menu"),
    rootPrefixCls: rootPrefixCls,
    dropdownArrowDistance: sizePopupArrow / 2 + marginXXS,
    dropdownArrowOffset: dropdownArrowOffset,
    dropdownPaddingVertical: dropdownPaddingVertical,
    dropdownEdgeChildPadding: paddingXXS
  });
  return [genBaseStyle(dropdownToken), genStatusStyle(dropdownToken)];
}, function (token) {
  return {
    zIndexPopup: token.zIndexPopupBase + 50
  };
});